<template>
    <el-menu
            :router="true"
            :default-active="$route.path"
            class="el-menu-demo"
            mode="horizontal"
            background-color="#545c64"
            text-color="#fff"
            active-text-color="#ffd04b">
        <el-menu-item index="/" @click="AllOrdersView" style="font-weight: 500">
            <template slot="title">
                <img :src="logo"
                     :style="logo_style"
                />
                Port Out Portal
            </template>
        </el-menu-item>
        <el-menu-item index="/all_orders" v-if="isLoggedIn && CheckLoggedIn()" @click="AllOrdersView">All Orders
        </el-menu-item>
        <el-menu-item index="/open_orders" v-if="isLoggedIn && CheckLoggedIn() && user.is_staff"
                      @click="OpenOrdersView">Open Orders
        </el-menu-item>
        <el-submenu style="float: right" index="4" v-if="isLoggedIn && CheckLoggedIn()">
            <template slot="title">
                <i class="el-icon-user-solid"></i>{{user.username}}
            </template>
            <el-menu-item index="/profile" @click="OpenProfile">Profile</el-menu-item>
            <el-menu-item index="2-2" @click="Logout">Logout</el-menu-item>
        </el-submenu>
    </el-menu>
</template>

<script>

    import {mapState} from "vuex";
    import moment from "moment";
    import store from "@/store";

    export default {
        name: "Navbar",
        props: ['logo', 'logo_style'],
        data() {
            return {
                activeLink: '/',
            };
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.activeLink = to.path
            })
        },
        beforeRouteUpdate(to, from, next) {
            this.activeLink = to.path
            next()
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            isLoggedIn: function () {
                return this.$store.getters['auth/isLoggedIn']
            }
        },
        methods: {
            CheckLoggedIn: function () {
                return this.$store.getters['auth/isLoggedIn'] && moment(store.getters["auth/expiraton_time"], "YYYY-M-D H:m").diff(moment(), 'minutes') > 0
            },
            Logout: function () {
                this.$store.dispatch('auth/logout')
                    .then(() => {
                        this.$router.push('/login')
                    })
            },
            OpenProfile: function () {
                if (this.CheckLoggedIn()) {
                    this.$store.dispatch('auth/openProfile', true)
                    this.$router.push('/profile').catch(error => {
                        if (error.name != "NavigationDuplicated") {
                            throw error;
                        }
                    });
                } else {
                    this.Logout()
                }
            },
            AllOrdersView: function () {
                if (this.CheckLoggedIn()) {
                    this.$router.push('/').catch(error => {
                        if (error.name != "NavigationDuplicated") {
                            throw error;
                        }
                    });
                } else {
                    this.Logout()
                }
            },
            OpenOrdersView: function () {
                if (this.CheckLoggedIn()) {
                    this.$router.push('/open_orders').catch(error => {
                        if (error.name != "NavigationDuplicated") {
                            throw error;
                        }
                    });
                } else {
                    this.Logout()
                }
            },
        },
    };
</script>

